import CrudActionContainer from './CrudActionContainer';
import AnalyticsController from '../controllers/AnalyticsController';
import commonHandler from '../errorHandlers/common-handler';
import { AnalyticsGranularity } from '../interfaces/analytics';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { Moment } from 'moment';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

class AnalyticsCRUDActions extends CrudActionContainer {
  retrievedForBotsAction: string;
  resetAnalyticsAction: string;

  constructor() {
    super('ANALYTICS');
    this.retrievedForBotsAction = this.makeActionKey('RETRIEVED_FOR_BOTS');
    this.resetAnalyticsAction = this.makeActionKey('RESET_ANALYTICS');
  }

  retrieveAll(
    botId: number,
    startDate: Moment,
    endDate: Moment,
    granularity: AnalyticsGranularity,
    filter?: string,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await AnalyticsController.getAll(
          botId,
          startDate.format('YYYY-MM-DD'),
          endDate.format('YYYY-MM-DD'),
          granularity,
          filter,
        );

        dispatch(this.retrieved(response));

        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  resetAnalytics() {
    return {
      type: this.resetAnalyticsAction,
    };
  }
}

const analyticsCRUDActions = new AnalyticsCRUDActions();

export default analyticsCRUDActions;

export const useAnalyticsCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return useMemo(
    () => ({
      retrieveAll: (
        ...args: Parameters<typeof analyticsCRUDActions.retrieveAll>
      ) => dispatch(analyticsCRUDActions.retrieveAll(...args)),
    }),
    [dispatch],
  );
};
